import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ItemMarcaMultiselectComponent } from './item-marca-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ItemMarcaMultiselectComponent
    ],
    exports: [
        ItemMarcaMultiselectComponent
    ]
})
export class ItemMarcaMultiselectModule { }
